import { cn } from '@/styles/utils';
import React from 'react';

interface PageSizeButtonProps {
  value: string | number;
  rounded?: 'none' | 'left' | 'right';
  isSelected?: boolean;
  onClick?: () => void;
  className?: string;
}

export const PageSizeButton: React.FC<PageSizeButtonProps> = ({
  value,
  rounded = 'none',
  isSelected = false,
  onClick,
  className,
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        'min-w-13 h-8 px-1.5 py-0 text-14r border-[#B1BBC9] border',
        rounded === 'none' && 'rounded-lg',
        rounded === 'left' && 'rounded-l-lg',
        rounded === 'right' && 'rounded-r-lg',
        isSelected
          ? 'bg-[#FFF4EF] text-[#F9552C] border-[#FFCCBA]'
          : 'bg-white text-[#475467]',
        rounded === 'left' && !isSelected && 'border-r-transparent',
        rounded === 'right' && !isSelected && 'border-l-transparent',
        className,
      )}
    >
      {value}
    </button>
  );
};
